export enum FieldType {
  BOOLEAN = 'boolean',
  CAMPAIGN_LABEL_ID = 'campaignLabelId',
  DATE = 'date',
  FLOAT = 'double',
  GEO_LOCATION = 'geo_location',
  INTEGER = 'long',
  KEYWORD = 'keyword', // ES5StringType string value (see ESFieldMapping.scala)
  OBJECT = 'object',
  STRING = 'string', // ES1StringType string value
  NESTED = 'nested',
  UNDEFINED = 'undefined',
}
